import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import global_inputs from './global/index'
import axios from 'axios'
import LazyLoad from './global/directives/LazyLoad'

const app = createApp(App)

app.config.productionTip = false

const gcomponents = [...global_inputs]
gcomponents.forEach(component => {
  app.component(component.name, component)
})

// directives
app.directive('lazyload', LazyLoad)

app.config.globalProperties.$axios = axios

app.use(router).use(store).mount('#app')
